import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {NavLink, withRouter} from 'react-router-dom';
import TrackingInputForm from "../TrackingInputForm/TrackingInputForm";
import {requestShipmentData, resetNoResultsShipmentData} from "../../actions/shipmentDataActions";
import queryString from "query-string";
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';

class Tracking extends Component {
  constructor(props) {
    super(props);
    this.defaultAirlineCode = '526';
    this.state = {
      trackingInfo: [
        {
          id: 1,
          airlineCode: this.defaultAirlineCode,
          trackingNumber: '',
          showDelete: false,
          isAirlineCodeValid: true,
          isTrackingNumberValid: true
        }
      ],
      errorCount: 0,
      lastKeyId: 1
    };
  };

  componentDidMount() {
    this.initializeTrackingInfo();
  }

  initializeTrackingInfo = () => {
    const querystringParams = queryString.parse(this.props.location.search);
    const validTrackingIds = querystringParams.validIds;
    const invalidTrackingIds = querystringParams.invalidIds;
    let count = 1;
    let trackingInfo = [];

    if(validTrackingIds !== undefined) {
      if(validTrackingIds.length > 0) {
        let trackingInfoData = validTrackingIds.split(',');
        for (let i = 0; i < trackingInfoData.length; i++) {
          // The data should come as airlineCode - trackingNumber
          const trackingInfoSplittedData = trackingInfoData[i].split('-');
          if (trackingInfoSplittedData.length === 2) {
            const trackingData = {
              id: count,
              airlineCode: trackingInfoSplittedData[0],
              trackingNumber: trackingInfoSplittedData[1],
              showDelete: true,
              isAirlineCodeValid: true,
              isTrackingNumberValid: true
            };
            trackingInfo.push(trackingData);
            count++;
          }
        }
      }
    }

    if(invalidTrackingIds !== undefined) {
      if(invalidTrackingIds.length > 0) {
        let trackingInfoData = invalidTrackingIds.split(',');
        for (let i = 0; i < trackingInfoData.length; i++) {
          // The data should come as airlineCode - trackingNumber
          const trackingInfoSplittedData = trackingInfoData[i].split('-');
          if (trackingInfoSplittedData.length === 2) {
            const trackingData = {
              id: count,
              airlineCode: trackingInfoSplittedData[0],
              trackingNumber: trackingInfoSplittedData[1],
              showDelete: true,
              isAirlineCodeValid: true,
              isTrackingNumberValid: false
            };
            trackingInfo.push(trackingData);
            count++;
          }
        }
      }
    }

    if(trackingInfo.length === 1)
    {
      trackingInfo[0].showDelete = false;
    }

    if(trackingInfo.length > 0)
    {
      this.setState({
        trackingInfo: trackingInfo,
        lastKeyId: count
      });
    }
  };

  // handle when input value changes
  onChange = (field, value, id) => {
    // If there were no results from the previous search clear error and start over
    if(this.props.noResults) {
      this.props.resetNoResultsShipmentData();
    }

    // Change the state
    const index = this.state.trackingInfo.findIndex((inputElement) => inputElement.id === id);
    let inputs = [...this.state.trackingInfo];
    if (field === 'airlineCode') {
      inputs[index].airlineCode = value;
    }
    else if (field === 'trackingNumber') {
      inputs[index].trackingNumber = value;
    }
    this.setState({trackingInfo: inputs});
  };

  validateAirlineCodeAndUpdateState = (value, id) => {
    const index = this.state.trackingInfo.findIndex((inputElement) => inputElement.id === id);
    let inputs = [...this.state.trackingInfo];
    inputs[index].isAirlineCodeValid = this.validateAirlineCode(value);
    this.setState({trackingInfo: inputs, errorCount: this.getErrorCount(inputs)});
  };

  validateAirlineCode = (airlineCode) => {
    if (airlineCode.trim() === '')
      return false;
    return true;
  };

  validateTrackingNumberAndUpdateState = (value, id) => {
    const index = this.state.trackingInfo.findIndex((inputElement) => inputElement.id === id);
    let inputs = [...this.state.trackingInfo];
    inputs[index].isTrackingNumberValid = this.validateTrackingNumber(value);
    this.setState({trackingInfo: inputs, errorCount: this.getErrorCount(inputs)});
  };

  validateTrackingNumber = (trackingNumber) => {
    if (trackingNumber.trim() === '' || trackingNumber.trim().length < 8)
      return false;
    return true;
  };


  addAirWaybill = () => {
    let trackingInputs = this.state.trackingInfo;
    const nextId = this.state.lastKeyId + 1;
    let tempTrackingInfo =
      {
        id: nextId,
        airlineCode: this.defaultAirlineCode,
        trackingNumber: '',
        showDelete: true,
        isAirlineCodeValid: true,
        isTrackingNumberValid: true
      }

    trackingInputs.push(tempTrackingInfo);
    if(trackingInputs.length > 1)
    {
      trackingInputs.forEach(trackingInput => {
        trackingInput.showDelete = true;
      })
    }

    this.setState({
      trackingInfo: trackingInputs,
      lastKeyId: nextId
    });
  };


  deleteRow = (id) => {
    const index = this.state.trackingInfo.findIndex((inputElement) => inputElement.id === id);
    let trackinginputs = [...this.state.trackingInfo];
    trackinginputs.splice(index, 1);
    // If only one input make sure there is no delete button next to it
    if(trackinginputs.length === 1)
    {
      trackinginputs[0].showDelete = false;
    }
    const errorCount = this.getErrorCount(trackinginputs);
    this.setState({trackingInfo: trackinginputs,
                  errorCount: errorCount});
  };

  getAddAnotherAirWaybillStyle = () => {
    //don't show Add another Air Waybill if there are already 10 rows
    if (this.state.trackingInfo.length < 10)
      return 'tracking-add-another-bill';
    else
      return 'tracking-add-another-bill-hide';
  };

  getErrorMessage = () => {
    let errorMessage = '';

    if (this.props.serviceError) {
      return 'This feature is currently not available. Please try again. If the error continues, please call our Customer CARE Center at 1 (800) 533-1222.';
    }

    if(this.props.noResults) {
      errorMessage = "The air waybill number(s) were not found.";
    } else {
      if (this.state.errorCount > 1)
        errorMessage = "There are multiple errors with your submission. Please review and try again.";
      else if (this.state.errorCount === 1) {
        //find if there is an error in tracking bill
        this.state.trackingInfo.forEach((trackingInput) => {
          if (trackingInput.isTrackingNumberValid === false)
            errorMessage = "Please enter an 8-digit air waybill."
        });

        if (errorMessage.length === 0) {
          errorMessage = "Please enter an airline code."
        }
      }
    }
    return errorMessage;
  };


  getErrorCount = (inputs) => {
    let count = 0;
    inputs.forEach((trackingInput, index) => {
      if (trackingInput.isTrackingNumberValid === false)
        count++;
      if (trackingInput.isAirlineCodeValid === false)
        count++;
    });
    return count;
  };


  handleSubmit = (e) => {
    e.preventDefault();
    let inputs = [...this.state.trackingInfo];
    //validate all fields
    this.state.trackingInfo.forEach((trackingInput, index) => {
      inputs[index].isTrackingNumberValid = this.validateTrackingNumber(trackingInput.trackingNumber);
      inputs[index].isAirlineCodeValid = this.validateAirlineCode(trackingInput.airlineCode);
    });

    this.setState({trackingInfo: inputs});

    let count = this.getErrorCount(inputs);
    this.setState({errorCount: count});

    // If np validation error call api to get data
    if (count === 0) {
      const trackingInfoToSend = this.state.trackingInfo.map(({ airlineCode, trackingNumber}) => ({ airlineCode, trackingNumber}));
      this.props.requestShipmentData(trackingInfoToSend, {nextUrl: this.props.location.pathname});
    }
  };

  getStyleForErrorMessage = () => {
    if (this.state.errorCount > 0 || this.props.noResults || this.props.serviceError)
      return "tracking-error-wrapper alert alert-danger";
  };

  render() {

    return (

      <div>
        <div className={this.getStyleForErrorMessage()}>  {this.getErrorMessage()} </div>
        <form onSubmit={this.handleSubmit} noValidate>

          {this.state.trackingInfo.map(inputElement => (
            <TrackingInputForm
                key={inputElement.id}
                id={inputElement.id}
                airlineCode={inputElement.airlineCode}
                trackingNumber={inputElement.trackingNumber}
                showDelete={inputElement.showDelete}
                isAirlineCodeValid={inputElement.isAirlineCodeValid}
                isTrackingNumberValid={inputElement.isTrackingNumberValid}
                onChange={this.onChange}
                deleteRow={this.deleteRow}
                validateAirlineCodeAndUpdateState={this.validateAirlineCodeAndUpdateState}
                validateTrackingNumberAndUpdateState={this.validateTrackingNumberAndUpdateState}
            />
          ))}
          <div className={this.getAddAnotherAirWaybillStyle()}>
            <span onClick={this.addAirWaybill}>
            <img className="tracking-add-another-bill__icon" src="./assets/icons/plus-sign.svg" alt="Add Air Waybill"/>
            <span className="tracking__link"> Add another air waybill</span>
            </span>
            <span className="tracking-add-another-bill__text2"> (maximum of 10 total)</span>
          </div>

          <div className="tracking-bottom-panel">
              <button type="submit" className="button cta-button tracking__button" disabled={this.props.isFetching}>
                  <span className="tracking-button__text"> Track </span>
              </button>
            {this.props.showAdvancedSearchLink === true &&
            <NavLink to={{
              pathname: '/manage/tracking',
              search: "advanced=true"
            }} className="tracking-advanced-search__link">
              Advanced Search </NavLink>
            }
          </div>
        </form>
          <Modal open={this.props.isFetching}
                 disableBackdropClick={true}
                 disableAutoFocus={true}>
              <CircularProgress className={'tracking-circular-progress'}/>
          </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  noResults: state.shipmentData.noResults,
  serviceError: state.shipmentData.error,
  isFetching: state.shipmentData.isFetching
});

Tracking.propTypes = {
  requestShipmentData: PropTypes.func.isRequired,
  resetNoResultsShipmentData: PropTypes.func.isRequired,
  isFetching: PropTypes.bool
};

Tracking.defaultProps = {
  isFetching: false
};

export default withRouter(connect(
  mapStateToProps,
  {requestShipmentData, resetNoResultsShipmentData}
)(Tracking));




// WEBPACK FOOTER //
// ./src/components/Tracking/Tracking.js